export default "__VITE_ASSET__9bdae261__"